import { render, staticRenderFns } from "./FormSuccess.vue?vue&type=template&id=48cf5b37&scoped=true"
import script from "./FormSuccess.vue?vue&type=script&lang=js"
export * from "./FormSuccess.vue?vue&type=script&lang=js"
import style0 from "./FormSuccess.vue?vue&type=style&index=0&id=48cf5b37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cf5b37",
  null
  
)

export default component.exports